let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("apyKY")).then(() => parcelRequire('9k7z3'));